import AxL from "./axl.js";
import Artwork from "./Artwork.js";
import Zoom from "./Zoom.js";
import DraggableModal from "./DraggableModal.js";
import Firebase from "./Firebase.js";
export default class Puzzle {
  constructor(scope, config) {
    console.log("init html5puzzle");
    ///////////////////
    this.scope = scope;
    this.config = config;
    this.currentZoom = 1;
    this.zoom_target = { x: 0, y: 0 };
    this.paperzoom = new Zoom(scope);
    this.currentStatus = null;
    this.isReady = false;
    this.setConfig(config);
    this.generateTiles();
  }

  verifyWebViewPosition(center = false) {
    let offset;
    const { delta, realPos, width, height } = this.detectBorders();
    // this.test();
    if (delta) {
      //lerp to border
      if (center) {
        const diffX = realPos.x - window.innerWidth / 2;
        const diffY = realPos.y - window.innerHeight / 2;
        const diff = new this.scope.paper.Point(diffX, diffY);
        offset = diff.divide(this.currentZoom);
      } else {
        offset = delta.divide(this.currentZoom);
      }
      let currentScroll = this.scope.paper.view.currentScroll.add(offset);
      this.scope.paper.view.scrollBy(currentScroll);
      // should zoom too in V2
    }
  }

  detectBorders() {
    let smaller = new this.scope.paper.Point(10000000, 10000000);
    let bigger = new this.scope.paper.Point(-10000000, -10000000);
    for (const child of this.scope.paper.project.activeLayer.children) {
      if (child.position.x > bigger.x) {
        bigger.x = child.position.x;
      }
      if (child.position.y > bigger.y) {
        bigger.y = child.position.y;
      }
      if (child.position.x < smaller.x) {
        smaller.x = child.position.x;
      }
      if (child.position.y < smaller.y) {
        smaller.y = child.position.y;
      }
    }
    this.detector = new this.scope.paper.Path.Rectangle(
      new this.scope.paper.Rectangle(smaller, bigger)
    );
    // this.detector.style = {
    // 	fillColor: new this.scope.paper.Color(1, 0, 0, 0.2),
    // 	strokeColor: 'red',
    // 	strokeWidth: 1
    // };

    // transpose to screen coord:
    const realPos = this.scope.paper.view.projectToView(this.detector.position);
    const realBig = this.scope.paper.view.projectToView(bigger);
    const realSmall = this.scope.paper.view.projectToView(smaller);
    const width = realBig.x - realSmall.x;
    const height = realBig.y - realSmall.y;
    const delta = new this.scope.paper.Point(0, 0);
    if (realPos.x + width / 2 < 0) {
      delta.x = realPos.x + width / 3;
    }
    if (realPos.y + height / 2 < 0) {
      delta.y = realPos.y + height / 3;
    }
    if (realPos.x - width / 2 > window.innerWidth) {
      delta.x = realPos.x - window.innerWidth - width / 3;
    }
    if (realPos.y - height / 2 > window.innerHeight) {
      delta.y = realPos.y - window.innerHeight - height / 3;
    }
    if (
      realPos.x + width / 2 < 0 ||
      realPos.y + height / 2 < 0 ||
      realPos.x - width / 2 > window.innerWidth ||
      realPos.y - height / 2 > window.innerHeight
    ) {
      return { delta, realPos, width, height };
    }

    return false;
  }

  getDirectInfos(isDriver) {
    const shareButton = document.querySelector(".shareButton");
    shareButton.removeEventListener("click", this.scope.shareHandler);
    shareButton.addEventListener("click", this.scope.shareHandler);
    let json = {};
    if (this.scope.unlisted_data) {
      console.log("unlisted data", this.scope.unlisted_data);
      json = {
        parsed: {
          title: this.scope.unlisted_data.title,
          creator: this.scope.unlisted_data.creator,
          collection: this.scope.unlisted_data.collection,
          thumbnail: this.scope.unlisted_data.url,
        },
        id: this.scope.unlisted_data.id,
      };
    } else {
      json = {
        parsed: {
          title: this.scope.gallery.imageDict[this.scope.active_asset_id].title,
          creator:
            this.scope.gallery.imageDict[this.scope.active_asset_id].creator,
          collection:
            this.scope.gallery.imageDict[this.scope.active_asset_id].collection,
          thumbnail:
            this.scope.gallery.imageDict[this.scope.active_asset_id].url,
        },
        id: this.scope.gallery.imageDict[this.scope.active_asset_id].id,
      };
    }

    this.scope.artwork = new Artwork(
      json,
      this.scope,
      this.scope.artworkInfo.content_
    );
    this.draggableModal = new DraggableModal(this.scope, json);
    if (isDriver) {
      console.log("open");
      //this.scope.artworkInfo.open();
    } else {
      let Smessage = "";
      //here we should keep the modal if too many people
      if (this.scope.USER_AMOUNT >= this.scope.USER_LIMIT) {
        console.log("TOO MANY USER. PLEASE start a new one.");
        // update values...
        Smessage = this.scope.translator
          ? this.scope.translator.get("too_many")
          : "Too many players here.";
        this.specialMessagePopUp(Smessage);
      } else if (this.scope.GAME_STATE == "win") {
        Smessage = this.scope.translator
          ? this.scope.translator.get("solved")
          : "Puzzle already solved.";
        this.specialMessagePopUp(Smessage);
      } else {
        console.log("close", this.scope.artworkInfo, "check WINING STATE");
        if (this.scope.artworkInfo) this.scope.artworkInfo.close();
        if (!this.scope.isMobile) this.draggableModal.open();
      }
    }
  }

  setConfig(config) {
    console.log(config);
    this.activeGroup = config.activeGroup;
    this.zoomScaleOnDrag = config.zoomScaleOnDrag;
    this.imgName = config.imgName;
    this.imgUrl = config.imgUrl;
    this.shadowWidth = config.shadowWidth;
    this.puzzleImage = new this.scope.paper.Raster(config.imgSrc);
    this.puzzleImage.position = this.scope.paper.view.center;
    this.puzzleImage.visible = false;
    this.tileWidth = config.tileWidth;
    this.tilesPerRow = Math.ceil(config.imgWidth / config.tileWidth);
    this.tilesPerColumn = Math.ceil(config.imgHeight / config.tileWidth);
    this.tileMarginWidth = this.tileWidth * 0.203125;
    this.selectedTile = undefined;
    this.selectedTileIndex = undefined;
    this.selectionGroup = undefined;
    this.shadowScale = 1.5;
    this.tilesDict = {};
    this.selectionGroupDict = {};
    this.clonedDict = {};
    this.originalCellSafety = {};
    if (!document.body.classList.contains("game"))
      document.body.classList.add("game");
  }
  async generateTiles() {
    let FirebaseData = null;
    let _storedShapeArray = null;
    let _positionIndexes = null;
    let _cellpositions = null;
    if (this.scope.game_id && !this.scope.direct_img) {
      console.log("game_id is set");
      FirebaseData = await this.getRecordedShapeArray();
    } else {
      console.log("no game id");
    }
    if (FirebaseData) {
      // this.scope.artworkInfo.close();
      const url = await this.scope.getURLFromAssetID(FirebaseData.assetID);
      const img = await this.loadImage(url);
      // const img = await this.loadImage(FirebaseData.asset);
      this.config.imgSrc = img;
      this.config.imgUrl = img.src;
      this.config.imgWidth = img.width;
      this.config.imgHeight = img.height;
      this.scope.active_asset_id = FirebaseData.assetID;
      this.scope.presetDifficulty = FirebaseData.level;
      _storedShapeArray = JSON.parse(FirebaseData.shapeArray);
      _positionIndexes = JSON.parse(FirebaseData.positionIndexes);
      _cellpositions = JSON.parse(FirebaseData.cellpositions);

      //setup pieces
      const piece = document.getElementById("template");
      const path = piece.getAttribute("data-path");
      switch (this.scope.presetDifficulty) {
        case "beginer":
          piece.src = "./images/empty_white_360.png";
          this.config.tileWidth = 256;
          break;
        case "intermediate":
          piece.src = "./images/empty_white_180.png";
          this.config.tileWidth = 128;
          break;
        case "expert":
          piece.src = "./images/empty_white.png";
          this.config.tileWidth = 64;
          break;
      }

      this.setConfig(this.config);
    }
    setTimeout(() => {
      const { pieces, shapeArray, positionIndexes, cellpositions } =
        this.generatePieces(
          this.tilesPerRow,
          this.tilesPerColumn,
          _storedShapeArray,
          _positionIndexes,
          _cellpositions
        );
      this.tiles = pieces;
      this.initialPositionIndexes = positionIndexes;
      // ADD ALL TILES !! NEW
      const piecesState = {};
      const piecesStatus = {};
      for (const tile of this.tiles) {
        this.scope.paper.project.activeLayer.addChild(tile);
        piecesState[tile.tilename] = { val: true };
        piecesStatus[tile.tilename] = { available: true };
      }
      if (document.body.getElementsByClassName("remoteLoader")[0]) {
        document.body.removeChild(
          document.body.getElementsByClassName("remoteLoader")[0]
        );
      }
      this.showGroupNavigation();

      this.currentStatus = "launched";
      if (!FirebaseData) {
        this.scope.game_id = this.scope.UID;
        // send to AXL
        if (this.scope.axl)
          this.scope.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
            puzzleId: this.scope.UID,
            gallery: this.scope.customGallery,
          });
        // share this tiles to FB
        console.log("▲", this.scope.active_asset_id);

        this.scope.send("/GAMES/" + this.scope.UID + "/datas", {
          asset: this.imgUrl,
          assetID: this.scope.active_asset_id,
          level: this.scope.presetDifficulty,
          shapeArray: JSON.stringify(shapeArray),
          positionIndexes: JSON.stringify(positionIndexes),
          cellpositions: JSON.stringify(cellpositions),
          win: false,
          date: new Date().getTime(),
          pieces: piecesState,
          pieceStatus: piecesStatus,
        });
      }

      if (this.scope.active_asset_id != "1234") {
        this.getDirectInfos(!FirebaseData);
      } else {
        this.scope.artworkInfo.close();
      }
      // scroll paper
      this.scope.paper.view.scrollBy(new this.scope.paper.Point(0, 200));
      // check to re-center....
      this.verifyWebViewPosition(true);
    }, 500);
  }
  getRecordedShapeArray() {
    return new Promise((resolve) => {
      Firebase.listenOnce(
        "/GAMES/" + this.scope.game_id + "/datas",
        (snapshot) => {
          const value = snapshot.val();
          resolve(value);
        }
      );

      // this.scope.database
      //   .ref("/GAMES/" + this.scope.game_id + "/datas")
      //   .once("value")
      //   .then((snapshot) => {
      //     const value = snapshot.val();
      //     //Define image -->
      //     //Define shapeArray-->
      //     resolve(value);
      //   });
    });
  }
  generatePieces(
    xTileCount,
    yTileCount,
    _storedShapeArray = null,
    _positionIndexes = null,
    _cellpositions = null
  ) {
    let pieces = new Array();
    let tileRatio = this.tileWidth / 100.0;

    let shapeArray =
      _storedShapeArray || this.getRandomShapes(xTileCount, yTileCount);
    let positionIndexes = _positionIndexes || [];
    let cellpositions = _cellpositions || [];
    let tileIndexes = new Array();
    let sw = 0;
    let offsetX = (this.tileWidth * xTileCount - this.config.imgWidth) / 2;
    let offsetY = (this.tileWidth * yTileCount - this.config.imgHeight) / 2;
    console.log(yTileCount, xTileCount);
    let cloneImg = this.puzzleImage.clone();
    for (let y = 0; y < yTileCount; y++) {
      for (let x = 0; x < xTileCount; x++) {
        let shape = shapeArray[y * xTileCount + x];
        let mask = this.getMask(
          tileRatio,
          shape.topTab,
          shape.rightTab,
          shape.bottomTab,
          shape.leftTab,
          this.tileWidth
        );
        mask.opacity = 0.25;
        let img = this.getImageSource(
          cloneImg,
          new this.scope.paper.Size(this.tileWidth, this.tileWidth),
          new this.scope.paper.Point(
            this.tileWidth * x - offsetX,
            this.tileWidth * y - offsetY
          )
        );
        let border = mask.clone();
        border.opacity = 1;
        border.fillColor = "white";

        let tile = new this.scope.paper.Group(mask, border, img);
        tile.clipped = true;
        tile.opacity = 1;

        const r_tile = tile.rasterize();
        tile.visible = false;
        tile.remove();
        img.remove();
        cloneImg.remove();
        mask.remove();
        border.remove();

        r_tile.shape = shape;
        r_tile.tilename = tileIndexes.length;
        r_tile.isfree = true;

        if (!this.scope.isMobile) {
          r_tile.onMouseMove = (e) => {
            const dist = e.point.getDistance(e.target.position);
            if (
              e.point.getDistance(e.target.position) <
                (this.tileWidth / 2) * 1.2 &&
              !e.target.isRemotelyControled
            ) {
              this.scope.setCursor(1);
            } else {
              this.scope.setCursor(0);
            }
          };
        }

        pieces.push(r_tile);
        tileIndexes.push(tileIndexes.length);
        //add dict
        this.tilesDict[r_tile.tilename.toString()] = r_tile; // tile;
        sw++;
        this.scope.paper.project.activeLayer.removeChildren();
      }
    }
    this.puzzleImage.remove();
    const goForRandomize = positionIndexes.length == 0 ? true : false;

    this.zoom(-0.6);
    this.generateRandomPosition(
      pieces,
      goForRandomize,
      tileIndexes,
      positionIndexes,
      cellpositions,
      xTileCount,
      yTileCount
    );
    return { pieces, shapeArray, positionIndexes, cellpositions };
  }
  generateRandomPosition(
    tiles,
    goForRandomize,
    tileIndexes,
    positionIndexes,
    cellpositions,
    xTileCount,
    yTileCount
  ) {
    if (cellpositions.length > 0) {
      console.log("remote");
    } else {
      for (let y = 0; y < yTileCount; y++) {
        for (let x = 0; x < xTileCount; x++) {
          cellpositions.push(null);
        }
      }
    }

    let w = 0;
    let index1;
    for (let y = 0; y < yTileCount; y++) {
      for (let x = 0; x < xTileCount; x++) {
        let index2;
        if (goForRandomize) {
          index1 = Math.floor(Math.random() * tileIndexes.length);
          index2 = tileIndexes[index1];
          positionIndexes.push(index2);
          this.scope.removeFromArray(tileIndexes, index1, 1);
        } else {
          index2 = positionIndexes[w];
        }

        let tile = tiles[index2];
        let position = this.scope.paper.view.center
          .subtract(
            new this.scope.paper.Point(this.tileWidth, this.tileWidth / 2)
          )
          .add(
            new this.scope.paper.Point(
              this.tileWidth * (x * 2 + (y % 2)),
              this.tileWidth * y
            )
          )
          .subtract(
            new this.scope.paper.Point(
              this.puzzleImage.size.width,
              this.puzzleImage.size.height / 2
            )
          );

        let cellPosition = null;
        if (goForRandomize) {
          cellPosition = new this.scope.paper.Point(
            Math.round(position.x / this.tileWidth) + 1,
            Math.round(position.y / this.tileWidth) + 1
          );
          cellpositions[index2] = { x: cellPosition.x, y: cellPosition.y };
          this.cellPositionDiff = new this.scope.paper.Point(0, 0);
        } else {
          cellPosition = new this.scope.paper.Point(
            cellpositions[index2].x,
            cellpositions[index2].y
          );
          this.cellPositionDiff = new this.scope.paper.Point(0, 0);
        }

        tile.position = cellPosition.multiply(this.tileWidth);
        tile.cellPosition = cellPosition;
        tile.originalCellPosition = cellPosition;
        w++;
      }
    }
  }
  /**
   *
   * OPTIONAL FUNCTION TO GENEREATE AN EQUIDISTANT GRID WITH PIECES
   */

  // generateGrid(tiles, goForRandomize, cellpositions, xTileCount, yTileCount) {
  // 	let w = 0;
  // 	for (let y = 0; y < yTileCount; y++) {
  // 		for (let x = 0; x < xTileCount; x++) {
  // 			let tile = tiles[w];
  // 			let cellPosition = new this.scope.paper.Point(x * 1.5, y * 1.5);
  // 			tile.position = cellPosition
  // 				.multiply(this.tileWidth)
  // 				.add(new this.scope.paper.Point(this.tileWidth * 3 / 4, this.tileWidth * 3 / 4)); //.subtract(this.scope.paper.view.center);
  // 			w++;
  // 		}
  // 	}
  // }
  getRandomShapes(width, height) {
    let shapeArray = new Array();

    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        let topTab = undefined;
        let rightTab = undefined;
        let bottomTab = undefined;
        let leftTab = undefined;

        if (y == 0) topTab = 0;

        if (y == height - 1) bottomTab = 0;

        if (x == 0) leftTab = 0;

        if (x == width - 1) rightTab = 0;

        shapeArray.push({
          topTab: topTab,
          rightTab: rightTab,
          bottomTab: bottomTab,
          leftTab: leftTab,
        });
      }
    }

    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        let shape = shapeArray[y * width + x];

        let shapeRight =
          x < width - 1 ? shapeArray[y * width + (x + 1)] : undefined;

        let shapeBottom =
          y < height - 1 ? shapeArray[(y + 1) * width + x] : undefined;

        shape.rightTab =
          x < width - 1 ? this.getRandomTabValue() : shape.rightTab;

        if (shapeRight) shapeRight.leftTab = -shape.rightTab;

        shape.bottomTab =
          y < height - 1 ? this.getRandomTabValue() : shape.bottomTab;

        if (shapeBottom) shapeBottom.topTab = -shape.bottomTab;
      }
    }

    return shapeArray;
  }
  getRandomTabValue() {
    return Math.pow(-1, Math.floor(Math.random() * 2));
  }
  getMask(tileRatio, topTab, rightTab, bottomTab, leftTab, tileWidth) {
    let curvyCoords = [
      0, 0, 35, 15, 37, 5, 37, 5, 40, 0, 38, -5, 38, -5, 20, -20, 50, -20, 50,
      -20, 80, -20, 62, -5, 62, -5, 60, 0, 63, 5, 63, 5, 65, 15, 100, 0,
    ];

    let mask = new this.scope.paper.Path();
    let tileCenter = this.scope.paper.view.center;

    let topLeftEdge = new this.scope.paper.Point(-4, 4);

    mask.moveTo(topLeftEdge);

    //Top
    for (let i = 0; i < curvyCoords.length / 6; i++) {
      let p1 = topLeftEdge.add(
        new this.scope.paper.Point(
          curvyCoords[i * 6 + 0] * tileRatio,
          topTab * curvyCoords[i * 6 + 1] * tileRatio
        )
      );
      let p2 = topLeftEdge.add(
        new this.scope.paper.Point(
          curvyCoords[i * 6 + 2] * tileRatio,
          topTab * curvyCoords[i * 6 + 3] * tileRatio
        )
      );
      let p3 = topLeftEdge.add(
        new this.scope.paper.Point(
          curvyCoords[i * 6 + 4] * tileRatio,
          topTab * curvyCoords[i * 6 + 5] * tileRatio
        )
      );

      mask.cubicCurveTo(p1, p2, p3);
    }
    //Right
    let topRightEdge = topLeftEdge.add(
      new this.scope.paper.Point(tileWidth, 0)
    );
    for (let i = 0; i < curvyCoords.length / 6; i++) {
      let p1 = topRightEdge.add(
        new this.scope.paper.Point(
          -rightTab * curvyCoords[i * 6 + 1] * tileRatio,
          curvyCoords[i * 6 + 0] * tileRatio
        )
      );
      let p2 = topRightEdge.add(
        new this.scope.paper.Point(
          -rightTab * curvyCoords[i * 6 + 3] * tileRatio,
          curvyCoords[i * 6 + 2] * tileRatio
        )
      );
      let p3 = topRightEdge.add(
        new this.scope.paper.Point(
          -rightTab * curvyCoords[i * 6 + 5] * tileRatio,
          curvyCoords[i * 6 + 4] * tileRatio
        )
      );

      mask.cubicCurveTo(p1, p2, p3);
    }
    //Bottom
    let bottomRightEdge = topRightEdge.add(
      new this.scope.paper.Point(0, tileWidth)
    );
    for (let i = 0; i < curvyCoords.length / 6; i++) {
      let p1 = bottomRightEdge.subtract(
        new this.scope.paper.Point(
          curvyCoords[i * 6 + 0] * tileRatio,
          bottomTab * curvyCoords[i * 6 + 1] * tileRatio
        )
      );
      let p2 = bottomRightEdge.subtract(
        new this.scope.paper.Point(
          curvyCoords[i * 6 + 2] * tileRatio,
          bottomTab * curvyCoords[i * 6 + 3] * tileRatio
        )
      );
      let p3 = bottomRightEdge.subtract(
        new this.scope.paper.Point(
          curvyCoords[i * 6 + 4] * tileRatio,
          bottomTab * curvyCoords[i * 6 + 5] * tileRatio
        )
      );

      mask.cubicCurveTo(p1, p2, p3);
    }
    //Left
    let bottomLeftEdge = bottomRightEdge.subtract(
      new this.scope.paper.Point(tileWidth, 0)
    );
    for (let i = 0; i < curvyCoords.length / 6; i++) {
      let p1 = bottomLeftEdge.subtract(
        new this.scope.paper.Point(
          -leftTab * curvyCoords[i * 6 + 1] * tileRatio,
          curvyCoords[i * 6 + 0] * tileRatio
        )
      );
      let p2 = bottomLeftEdge.subtract(
        new this.scope.paper.Point(
          -leftTab * curvyCoords[i * 6 + 3] * tileRatio,
          curvyCoords[i * 6 + 2] * tileRatio
        )
      );
      let p3 = bottomLeftEdge.subtract(
        new this.scope.paper.Point(
          -leftTab * curvyCoords[i * 6 + 5] * tileRatio,
          curvyCoords[i * 6 + 4] * tileRatio
        )
      );

      mask.cubicCurveTo(p1, p2, p3);
    }

    return mask;
  }
  getImageSource(sourceRaster, size, offset) {
    let targetRaster = new this.scope.paper.Raster("template");
    let tileWithMarginWidth = size.width + this.tileMarginWidth * 2;
    let data = sourceRaster.getImageData(
      new this.scope.paper.Rectangle(
        offset.x - this.tileMarginWidth,
        offset.y - this.tileMarginWidth,
        tileWithMarginWidth,
        tileWithMarginWidth
      )
    );
    targetRaster.setImageData(data, new this.scope.paper.Point(0, 0));
    targetRaster.position = new this.scope.paper.Point(
      this.tileWidth / 2 - 4,
      this.tileWidth / 2 + 4
    );
    return targetRaster;
  }
  pickTile(point, delta, d) {
    this.scope.paper.project.activeLayer.selected = false;
    // if (delta.x < 8 && delta.y < 8) {
    let tolerance = this.tileWidth * 0.6;
    let hit = false;
    for (let index = 0; index < this.tiles.length; index++) {
      let tile = this.tiles[index];
      let row = parseInt(index / this.config.tilesPerRow);
      let col = index % this.config.tilesPerRow;
      let tileCenter = tile.position;
      let deltaPoint = tileCenter.subtract(point);
      hit =
        deltaPoint.x * deltaPoint.x + deltaPoint.y * deltaPoint.y <
        tolerance * tolerance;
      // const handshake = false;
      if (hit) {
        console.log(tile);
      }

      if (hit && tile.isfree && !tile.isRemotelyControled) {
        tile.isfree = false;
        this.selectedTile = tile;
        this.selectedTileIndex = index;
        tile.opacity = 0.5;
        tile.originalPosition = tile.position;
        tile.originalCellPosition = tile.cellPosition;
        console.log("on pick : ", tile.cellPosition);
        this.scope.paper.project.activeLayer.addChild(tile);
        tile.date = d;
        tile.master = tile.tilename;
        // clone
        // don't forget to unset cellposition to undefined
        const clonedTile = this.selectedTile.clone();
        clonedTile.opacity = 0.1;
        // this.clonedDict[this.selectedTile.tilename] = [ clonedTile ];
        this.clonedDict[this.selectedTile.tilename] = !this.clonedDict[
          this.selectedTile.tilename
        ]
          ? [clonedTile]
          : this.clonedDict[this.selectedTile.tilename].push(clonedTile);
        //
        if (this.activeGroup) {
          this.connectedTiles = this.detectConnectedTiles(tile);
          this.connectedTilesNames = [];
          for (const t of this.connectedTiles) {
            console.log(t.cellPosition);
            t.master = this.selectedTile.tilename;
            let diffFromMaster = t.cellPosition.subtract(
              tile.originalCellPosition
            );
            this.connectedTilesNames.push({
              tilename: t.tilename,
              cellPosition: { x: diffFromMaster.x, y: diffFromMaster.y },
              date: d,
              master: this.selectedTile.tilename,
            });
            //clone part
            // don't forget to unset cellposition to undefined
            const clonedPiece = t.clone();
            clonedPiece.opacity = 0.1;
            this.clonedDict[this.selectedTile.tilename].push(clonedPiece);
          }
        }
        break;
      } else if (!tile.isRemotelyControled) {
        tile.opacity = 1;
      } else {
        console.log("check if it is really free ?");
        if (hit && tile.isRemotelyControled) {
          console.log("deactivate drag.");
          this.deactivateDrag = true;
        }
      }
    }

    if (!hit) this.selectedTile = null;
    // }

    if (this.selectedTile) {
      if (!this.selectedTile.lastScale) {
        this.selectedTile.lastScale = this.zoomScaleOnDrag;
        this.selectedTile.secretScale = this.selectedTile.lastScale;
        // this.selectedTile.scale(this.selectedTile.lastScale);
      } else {
        if (this.selectedTile.lastScale > 1) {
          this.releaseTile();
          return;
        }
      }
      // this.selectedTile.cellPosition = undefined;
      this.selectionGroup = new this.scope.paper.Group(this.selectedTile);
      let pos = new this.scope.paper.Point(
        this.selectedTile.position.x,
        this.selectedTile.position.y
      );

      if (this.activeGroup)
        this.selectionGroup.addChildren(this.connectedTiles);

      let grouppos = new this.scope.paper.Point(
        this.selectionGroup.position.x,
        this.selectionGroup.position.y
      );

      let diffpos = grouppos.subtract(pos);

      this.selectedTile.position = new this.scope.paper.Point(0, 0)
        .add(pos)
        .add(diffpos);
      this.selectionGroup.position = pos;

      if (this.activeGroup) {
        // check diff.
        // reposition other tile around the selected one...
        for (const connectedTile of this.connectedTiles) {
          let diffFromMaster = connectedTile.cellPosition.subtract(
            this.selectedTile.originalCellPosition
          );
          connectedTile.position = diffFromMaster
            .multiply(this.tileWidth)
            .add(this.selectedTile.position);
          connectedTile.connectedPosition = connectedTile.cellPosition;
          // connectedTile.cellPosition = undefined; // reset position;
        }
      }

      this.selectionGroup.tilename = this.selectedTile.tilename;
    }
    const st = this.selectedTile;
    const ctn = this.connectedTilesNames || [];
    return [st, ctn];
  }

  remotePickTile(tilename, d, initialPositions, connectedTilesNames = []) {
    console.log("REMOTE PICK");

    const selectedTile = this.tilesDict[tilename];
    if (selectedTile.isfree) {
      selectedTile.isfree = false;
      selectedTile.isRemotelyControled = true;
      selectedTile.opacity = 0.5;
      selectedTile.originalPosition = selectedTile.position;
      this.scope.paper.project.activeLayer.addChild(selectedTile);

      if (!selectedTile.lastScale) {
        selectedTile.lastScale = this.zoomScaleOnDrag;
        selectedTile.secretScale = selectedTile.lastScale;
        // selectedTile.scale(selectedTile.lastScale);
      } else {
        if (selectedTile.lastScale > 1) {
          console.log("last scale bigger than one ?", selectedTile);
          // switch to remote release
          this.remoteReleaseTile(tilename);
          return;
        }
      }
      const clonedTile = selectedTile.clone();
      clonedTile.opacity = 0.1;
      this.clonedDict[selectedTile.tilename] = !this.clonedDict[
        selectedTile.tilename
      ]
        ? [clonedTile]
        : this.clonedDict[selectedTile.tilename].push(clonedTile);
      // selectedTile.cellPosition = undefined;

      const selectionGroup = new this.scope.paper.Group(selectedTile);
      let pos = new this.scope.paper.Point(
        selectedTile.position.x,
        selectedTile.position.y
      );

      if (connectedTilesNames.length != 0) {
        for (const t of connectedTilesNames) {
          // console.log('DATE SHOULD BE EQUIVALENT', d, t.date);
          // update that only when selected ---->  SO NOT HERE !!!
          this.tiles[t.tilename].isRemotelyControled = true;
          this.tiles[t.tilename].date = t.date;
          console.log(this.tiles[t.tilename].cellPosition);
          //clone part
          // don't forget to unset cellposition to undefined
          const clonedPiece = this.tiles[t.tilename].clone();
          clonedPiece.opacity = 0.1;
          this.clonedDict[selectedTile.tilename].push(clonedPiece);

          selectionGroup.addChild(this.tiles[t.tilename]);
        }
      }

      let grouppos = new this.scope.paper.Point(
        selectionGroup.position.x,
        selectionGroup.position.y
      );
      let diffpos = grouppos.subtract(pos);
      let ref = new this.scope.paper.Point(0, 0).add(grouppos); //.add(diffpos);
      console.log(pos, grouppos, diffpos, ref);

      selectedTile.position = ref;
      selectionGroup.position = pos;
      if (connectedTilesNames.length != 0) {
        this.originalCellSafety[selectedTile.tilename] = [];
        for (const t of connectedTilesNames) {
          //prioritize GROUP ...
          if (!this.tiles[t.tilename].isfree) {
            this.releaseTile();
            this.deactivateDrag = true;
            console.log("GO RELEASE, BUT NEED TO KEEP GROUP");
            console.log("check timing");
          }
          this.originalCellSafety[selectedTile.tilename].push({
            x: this.tiles[t.tilename].cellPosition.x,
            y: this.tiles[t.tilename].cellPosition.y,
            tilename: t.tilename,
          });

          this.tiles[t.tilename].cellPosition = new this.scope.paper.Point(
            t.cellPosition.x,
            t.cellPosition.y
          );
          console.log(this.tiles[t.tilename].cellPosition);

          this.tiles[t.tilename].position = this.tiles[t.tilename].cellPosition
            .multiply(this.tileWidth)
            .add(selectedTile.position);
          this.tiles[t.tilename].opacity = 0.5; //--> to be remove
          this.tiles[t.tilename].isfree = false;

          this.tiles[t.tilename].connectedPosition =
            this.tiles[t.tilename].cellPosition;
          // this.tiles[t.tilename].cellPosition = undefined;
        }
      }

      this.selectionGroupDict[tilename] = selectionGroup;
    } else {
      if (d < selectedTile.date) {
        console.log(
          "SORRY; IT WAS YOUNGER",
          initialPositions,
          connectedTilesNames
        );
        delete this.selectionGroupDict[tilename];
        this.disableFirebaseupdate = true;
      }
    }
  }

  releaseTile() {
    let storedName = null;
    this.connectedTilesNames = [];
    if (this.selectedTile && this.selectionGroup) {
      storedName = this.selectedTile.tilename.toString();
      let cellPosition = new this.scope.paper.Point(
        Math.round(this.selectedTile.position.x / this.tileWidth),
        Math.round(this.selectedTile.position.y / this.tileWidth)
      );

      let roundPosition = cellPosition.multiply(this.tileWidth);

      let hasConflict = false;

      let alreadyPlacedTile = this.getTileAtCellPosition(
        cellPosition,
        storedName
      );

      hasConflict = alreadyPlacedTile;

      let topTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(0, -1)),
        storedName
      );
      let rightTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(1, 0)),
        storedName
      );
      let bottomTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(0, 1)),
        storedName
      );
      let leftTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(-1, 0)),
        storedName
      );

      if (topTile) {
        hasConflict =
          hasConflict ||
          !(topTile.shape.bottomTab + this.selectedTile.shape.topTab == 0);
      }

      if (bottomTile) {
        hasConflict =
          hasConflict ||
          !(bottomTile.shape.topTab + this.selectedTile.shape.bottomTab == 0);
      }

      if (rightTile) {
        hasConflict =
          hasConflict ||
          !(rightTile.shape.leftTab + this.selectedTile.shape.rightTab == 0);
      }

      if (leftTile) {
        hasConflict =
          hasConflict ||
          !(leftTile.shape.rightTab + this.selectedTile.shape.leftTab == 0);
      }

      if (!hasConflict) {
        if (this.selectedTile.lastScale) {
          this.selectedTile.secretScale = 1 / this.selectedTile.lastScale;
          // this.selectedTile.scale(1 / this.selectedTile.lastScale);
          this.selectedTile.lastScale = undefined;
        }
        this.selectionGroup.remove();
        let tile = this.tiles[this.selectedTileIndex];
        let masterCellPosition = tile.originalCellPosition;
        tile.position = roundPosition;
        tile.cellPosition = cellPosition;
        // tile.originalCellPosition = cellPosition;
        tile.detected = false;
        tile.isfree = true;
        tile.opacity = 1;
        tile.master = null;

        if (this.activeGroup) {
          let problem = false;
          console.log("test");

          for (const connectedTile of this.connectedTiles) {
            let diffFromMaster = masterCellPosition.subtract(
              connectedTile.connectedPosition
            );
            connectedTile.connectedPosition =
              tile.cellPosition.subtract(diffFromMaster);
            // NEED TO CHECK IF ANY OF THE GROUP HAS A CONFLICT
            // !!
            problem = problem || this.detectConflict(connectedTile);
            connectedTile.cellPosition = connectedTile.connectedPosition;
            connectedTile.position = connectedTile.cellPosition.multiply(
              this.tileWidth
            );
            connectedTile.opacity = 1;
            connectedTile.detected = false;
            connectedTile.isfree = true;
            connectedTile.master = null;
          }
          if (problem) {
            this.resetPosition();
            const ctn = this.connectedTilesNames || [];
            this.deactivateDrag = false;
            this.disableFirebaseupdate = false;
            if (storedName) this.removeClones(storedName);
            return [storedName, ctn];
          } else {
            console.log("no problem");
            //--record the change
            this.connectedTilesNames = [];
            for (const t of this.connectedTiles) {
              this.connectedTilesNames.push({
                tilename: t.tilename,
                cellPosition: { x: t.cellPosition.x, y: t.cellPosition.y },
              });
            }
            this.scope.paper.project.activeLayer.addChildren(
              this.connectedTiles
            );
            this.connectedTiles = [];
          }
        }

        this.selectionGroup.remove();
        this.selectedTile = this.selectionGroup = null;
        this.scope.paper.project.activeLayer.addChild(tile);

        let errors = this.checkTiles();
        if (errors == 0) {
          // alert('Congratulations!!!');
          console.log("CONGRATULATIONS");
          this.win();
        }
      } else {
        console.log("HAS CONFLICT");
        // send back to original position.
        // this.resetPosition('hasconflict');
        // console.log('HAS NO CONFLICT');
        if (this.selectedTile.lastScale) {
          this.selectedTile.secretScale = 1 / this.selectedTile.lastScale;
          // this.selectedTile.scale(1 / this.selectedTile.lastScale);
          this.selectedTile.lastScale = undefined;
        }
        //this.selectionGroup.remove();
        let tile = this.tiles[this.selectedTileIndex];
        let masterCellPosition = tile.originalCellPosition;
        tile.position = tile.originalPosition;
        tile.cellPosition = tile.originalCellPosition;
        tile.detected = false;
        tile.isfree = true;
        tile.opacity = 1;
        tile.master = null;
        if (this.selectionGroup) this.selectionGroup.remove();
        this.selectedTile = this.selectionGroup = null;
        this.scope.paper.project.activeLayer.addChild(tile);

        if (this.activeGroup) {
          for (const connectedTile of this.connectedTiles) {
            let diffFromMaster = masterCellPosition.subtract(
              connectedTile.connectedPosition
            );
            connectedTile.cellPosition =
              tile.cellPosition.subtract(diffFromMaster);
            connectedTile.position = connectedTile.cellPosition.multiply(
              this.tileWidth
            );
            connectedTile.opacity = 1;
            connectedTile.detected = false;
            connectedTile.isfree = true;
            connectedTile.master = null;
          }
          this.connectedTilesNames = [];
          for (const t of this.connectedTiles) {
            this.connectedTilesNames.push({
              tilename: t.tilename,
              cellPosition: { x: t.cellPosition.x, y: t.cellPosition.y },
            });
          }
          this.scope.paper.project.activeLayer.addChildren(this.connectedTiles);
        }
        this.connectedTiles = [];
        console.log("RESOLVED CONFLICT", this.activeGroup);

        //should send the position to ensure the proper update !
        //--> FB
        // this.scope.setCursor(0);
      }
    } else if (this.selectedTile) {
      console.log("HAVE TO SEND BACK !!!");
      storedName = this.selectedTile.tilename.toString();

      if (this.selectedTile.lastScale) {
        this.selectedTile.secretScale = 1 / this.selectedTile.lastScale;
        // this.selectedTile.scale(1 / this.selectedTile.lastScale);
        this.selectedTile.lastScale = undefined;
      }
      let tile = this.tiles[this.selectedTileIndex];
      let masterCellPosition = tile.originalCellPosition;
      tile.position = tile.originalPosition;
      tile.cellPosition = tile.originalCellPosition;
      tile.detected = false;
      tile.isfree = true;
      tile.opacity = 1;
      tile.master = null;
      // this.selectionGroup.remove();
      this.selectedTile = this.selectionGroup = null;
      this.scope.paper.project.activeLayer.addChild(tile);
      if (this.activeGroup) {
        for (const connectedTile of this.connectedTiles) {
          let diffFromMaster = masterCellPosition.subtract(
            connectedTile.connectedPosition
          );
          connectedTile.cellPosition =
            tile.cellPosition.subtract(diffFromMaster);
          connectedTile.position = connectedTile.cellPosition.multiply(
            this.tileWidth
          );
          connectedTile.opacity = 1;
          connectedTile.detected = false;
          connectedTile.isfree = true;
          connectedTile.master = null;
        }
        this.connectedTilesNames = [];
        for (const t of this.connectedTiles) {
          this.connectedTilesNames.push({
            tilename: t.tilename,
            cellPosition: { x: t.cellPosition.x, y: t.cellPosition.y },
          });
        }
        this.scope.paper.project.activeLayer.addChildren(this.connectedTiles);
      }
      this.connectedTiles = [];
      // this.scope.setCursor(0);
    } else {
      // // console.log('stop drag');
      // const delta = this.detectBorders();
      // console.log('delta HERE');

      // // this.test();
      // if (delta) {
      // 	// console.log(delta);
      // 	//lerp to border
      // 	let currentScroll = this.scope.paper.view.currentScroll.add(delta.divide(this.currentZoom));
      // 	this.scope.paper.view.scrollBy(currentScroll);
      // }
      // // this.scope.setCursor(0);
      this.verifyWebViewPosition();
    }

    const ctn = this.connectedTilesNames || [];
    this.deactivateDrag = false;
    this.disableFirebaseupdate = false;
    if (storedName) this.removeClones(storedName);
    //this.activeGroup = this.config.activeGroup; //true;
    // this.unGroup();
    //this.scope.resetUI();
    return [storedName, ctn];
  }

  removeClones(tilename) {
    if (this.clonedDict[tilename]) {
      for (const clone of this.clonedDict[tilename]) {
        clone.remove();
      }
      delete this.clonedDict[tilename];
    }
  }

  resetPosition(special) {
    console.log("reset pos");
    if (this.selectedTile.lastScale) {
      this.selectedTile.secretScale = 1 / this.selectedTile.lastScale;
      // this.selectedTile.scale(1 / this.selectedTile.lastScale);
      this.selectedTile.lastScale = undefined;
    }
    //this.selectionGroup.remove();
    let tile = this.tiles[this.selectedTileIndex];
    let beforeRepositioning = new this.scope.paper.Point(
      tile.cellPosition.x,
      tile.cellPosition.y
    );

    // let masterCellPosition = tile.originalCellPosition;
    tile.position = tile.originalPosition;
    tile.cellPosition = tile.originalCellPosition;
    tile.detected = false;
    tile.isfree = true;
    if (this.selectionGroup) this.selectionGroup.remove();
    this.selectedTile = this.selectionGroup = null;
    this.scope.paper.project.activeLayer.addChild(tile);

    if (this.activeGroup) {
      for (const connectedTile of this.connectedTiles) {
        let diffFromMaster = beforeRepositioning.subtract(
          connectedTile.connectedPosition
        );
        connectedTile.cellPosition = tile.cellPosition.subtract(diffFromMaster);
        connectedTile.position = connectedTile.cellPosition.multiply(
          this.tileWidth
        );
        connectedTile.opacity = 1;
        connectedTile.detected = false;
        connectedTile.isfree = true;
      }
      this.connectedTilesNames = [];
      for (const t of this.connectedTiles) {
        this.connectedTilesNames.push({
          tilename: t.tilename,
          cellPosition: { x: t.cellPosition.x, y: t.cellPosition.y },
        });
      }
      this.scope.paper.project.activeLayer.addChildren(this.connectedTiles);
    }
    this.connectedTiles = [];
    //this.activeGroup = this.config.activeGroup; // true;
    // this.scope.setCursor(0);
  }

  remoteReleaseTile(tilename, finalpositions = null, connectedTilesNames = []) {
    console.log("REMOTE RELEASE", tilename, finalpositions);

    let selectedTile = this.tilesDict[tilename];
    let selectionGroup = this.selectionGroupDict[tilename];

    console.log("CHECK", selectedTile, selectionGroup);

    if (selectedTile && selectionGroup) {
      let cellPosition = new this.scope.paper.Point(
        Math.round(selectionGroup.position.x / this.tileWidth),
        Math.round(selectionGroup.position.y / this.tileWidth)
      );

      let roundPosition = cellPosition.multiply(this.tileWidth);

      let hasConflict = false;

      let alreadyPlacedTile = this.getTileAtCellPosition(cellPosition);

      hasConflict = alreadyPlacedTile;

      let topTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(0, -1))
      );
      let rightTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(1, 0))
      );
      let bottomTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(0, 1))
      );
      let leftTile = this.getTileAtCellPosition(
        cellPosition.add(new this.scope.paper.Point(-1, 0))
      );

      if (topTile) {
        hasConflict =
          hasConflict ||
          !(topTile.shape.bottomTab + selectedTile.shape.topTab == 0);
      }

      if (bottomTile) {
        hasConflict =
          hasConflict ||
          !(bottomTile.shape.topTab + selectedTile.shape.bottomTab == 0);
      }

      if (rightTile) {
        hasConflict =
          hasConflict ||
          !(rightTile.shape.leftTab + selectedTile.shape.rightTab == 0);
      }

      if (leftTile) {
        hasConflict =
          hasConflict ||
          !(leftTile.shape.rightTab + selectedTile.shape.leftTab == 0);
      }

      if (!hasConflict) {
        // console.log('HAS NO remote CONFLICT');
        if (selectedTile.lastScale) {
          selectedTile.secretScale = 1 / selectedTile.lastScale;
          // selectedTile.scale(1 / selectedTile.lastScale);
          selectedTile.lastScale = undefined;
        }

        selectionGroup.remove();
        let tile = this.tiles[tilename];
        tile.position = roundPosition;
        tile.cellPosition = cellPosition;
        tile.opacity = 1;
        tile.isfree = true;
        tile.isRemotelyControled = false;
        selectionGroup.remove();
        selectedTile = selectionGroup = null;
        this.selectionGroupDict[tilename] = null;
        this.scope.paper.project.activeLayer.addChild(tile);

        // DETECT CONFLICT HERE TOO !!!
        if (connectedTilesNames.length != 0) {
          for (const t of connectedTilesNames) {
            console.log(this.tiles[t.tilename], t);

            this.tiles[t.tilename].cellPosition = new this.scope.paper.Point(
              t.cellPosition.x,
              t.cellPosition.y
            );
            this.tiles[t.tilename].position = this.tiles[
              t.tilename
            ].cellPosition.multiply(this.tileWidth);
            // .add(tile.position);
            this.tiles[t.tilename].opacity = 1; //--> to be remove
            this.tiles[t.tilename].isfree = true;
            this.tiles[t.tilename].isRemotelyControled = false;
            this.scope.paper.project.activeLayer.addChild(
              this.tiles[t.tilename]
            );
          }
        }

        if (!finalpositions) {
          let errors = this.checkTiles();
          if (errors == 0) {
            //alert('Congratulations!!!');
            console.log("CONGRATULATIONS");
            this.win();
          }
        }
      } else {
        console.log("HAS remote CONFLICT");
        if (selectedTile.lastScale) {
          selectedTile.secretScale = 1 / selectedTile.lastScale;
          // selectedTile.scale(1 / selectedTile.lastScale);
          selectedTile.lastScale = undefined;
        }
        selectionGroup.remove();
        let tile = this.tiles[tilename];
        tile.position = tile.originalPosition;
        tile.isfree = true;
        tile.isRemotelyControled = false;
        tile.opacity = 1;
        selectionGroup.remove();
        selectedTile = selectionGroup = null;
        this.scope.paper.project.activeLayer.addChild(tile);

        if (connectedTilesNames.length != 0) {
          for (const t of connectedTilesNames) {
            this.tiles[t.tilename].cellPosition = new this.scope.paper.Point(
              t.cellPosition.x,
              t.cellPosition.y
            );
            this.tiles[t.tilename].position = this.tiles[
              t.tilename
            ].cellPosition.multiply(this.tileWidth);
            // .add(tile.position);
            this.tiles[t.tilename].opacity = 1; //--> to be remove
            this.tiles[t.tilename].isfree = true;
            this.tiles[t.tilename].isRemotelyControled = false;
            this.scope.paper.project.activeLayer.addChild(
              this.tiles[t.tilename]
            );
          }
        }
        console.log("PIECE SHOULD HAVE MOVE BACK");
      }

      // FORCE POSITION UPDATE !!
      if (finalpositions) {
        console.log("ENTER FINAL POSITION");

        let tile = this.tiles[tilename];
        //tile.position = finalpositions.position;
        tile.cellPosition = new this.scope.paper.Point(
          finalpositions.cellPosition.x,
          finalpositions.cellPosition.y
        );
        const newVal = tile.cellPosition.subtract(this.cellPositionDiff);
        tile.position = newVal.multiply(this.tileWidth);

        if (connectedTilesNames.length != 0) {
          console.log("CHANGE STATE ???");

          for (const t of connectedTilesNames) {
            console.log(t.tilename);

            this.tiles[t.tilename].cellPosition = new this.scope.paper.Point(
              t.cellPosition.x,
              t.cellPosition.y
            );
            this.tiles[t.tilename].position = this.tiles[
              t.tilename
            ].cellPosition.multiply(this.tileWidth);
            // .add(tile.position);
            // this.tiles[t.tilename].opacity = 1; //--> to be remove
            this.tiles[t.tilename].isfree = true;
            this.tiles[t.tilename].isRemotelyControled = false;
            // this.scope.paper.project.activeLayer.addChild(this.tiles[t.tilename]);
          }
        }

        let errors = this.checkTiles();
        if (errors == 0) {
          // alert('Congratulations!!!');
          console.log("CONGRATULATIONS");
          this.win();
        }
      }
    } else {
      console.log("DO SOME GENERAL UPDATE HERE");
      this.updateFinalPosition(tilename, finalpositions, connectedTilesNames);
    }

    if (tilename) this.removeClones(tilename);
    if (this.originalCellSafety[tilename])
      delete this.originalCellSafety[tilename];
  }

  updateFinalPosition(tilename, finalpositions, connectedTilesNames) {
    let selectedTile = this.tilesDict[tilename];
    if (selectedTile && selectedTile.isfree) {
      this.remotePickTile(tilename);
      this.remoteReleaseTile(tilename, finalpositions, connectedTilesNames);
    }
  }

  getTileAtCellPosition(point, master = null) {
    let width = this.tilesPerRow;
    let height = this.tilesPerColumn;
    let tile = undefined;
    for (let i = 0; i < this.tiles.length; i++) {
      if (
        point &&
        this.tiles[i].cellPosition &&
        this.tiles[i].cellPosition.x == point.x &&
        this.tiles[i].cellPosition.y == point.y &&
        (!master || this.tiles[i].master != master)
      ) {
        tile = this.tiles[i];
        break;
      }
    }
    // ADD EXTRA CALCULATION FOR ORIGINAL CELLS
    const allOriginals = Object.keys(this.originalCellSafety);
    for (const key of allOriginals) {
      for (let i = 0; i < this.originalCellSafety[key].length; i++) {
        const name = this.originalCellSafety[key][i].tilename;
        const tileMaster = this.originalCellSafety[key][i].master;
        if (
          point &&
          this.originalCellSafety[key][i].x == point.x &&
          this.originalCellSafety[key][i].y == point.y &&
          (!master || tileMaster != master)
        ) {
          tile = this.tiles[name];
          break;
        }
      }
    }
    return tile;
  }
  dragTile(delta, e = null) {
    let storedName = null;
    if (this.selectedTile && this.selectionGroup) {
      storedName = this.selectedTile.tilename.toString();
      this.selectionGroup.position = this.selectionGroup.position.add(delta);
      this.selectedTile.opacity = 1;
    } else if (
      !this.deactivateDrag &&
      ((e.event.touches &&
        this.scope.IS_INLINE &&
        e.event.touches.length == 2) ||
        !this.scope.IS_INLINE ||
        !e.event.touches)
    ) {
      let currentScroll = this.scope.paper.view.currentScroll.subtract(
        delta.multiply(this.currentZoom)
      );
      // let currentScroll = this.scope.paper.view.currentScroll.subtract(delta);
      this.scope.paper.view.scrollBy(currentScroll);
      this.scope.paper.view.currentScroll = currentScroll;
      // console.log(currentScroll, this.scope.paper.project.activeLayer.children);
    }
    return storedName;
  }
  remoteDragTile(delta, tilename, pos) {
    const deltaPoint = new this.scope.paper.Point(delta[1], delta[2]);
    const selectedTile = this.tilesDict[tilename];
    const selectionGroup = this.selectionGroupDict[tilename];
    if (selectedTile) {
      // selectionGroup.position = selectionGroup.position.add(deltaPoint);
      if (selectionGroup) {
        selectionGroup.position.x = pos.x;
        selectionGroup.position.y = pos.y;
      }

      selectedTile.opacity = 0.5;
    }

    /**
     *  remove AUTOMATIC DRAG ON BACKGROUND
     */

    // else {
    // 	let currentScroll = this.scope.paper.view.currentScroll.subtract(delta.multiply(this.currentZoom));
    // 	this.scope.paper.view.scrollBy(currentScroll);
    // 	this.scope.paper.view.currentScroll = currentScroll;
    // }
  }

  zoom(zoomDelta = null, event = null) {
    if (event) {
      // console.log(event.deltaY);
      let mousePosition = new paper.Point(event.x, event.y);
      let viewPosition = this.scope.paper.view.viewToProject(mousePosition);
      let _ref1 = this.paperzoom.stableChangeZoom(
        this.scope.paper.view.zoom,
        event.deltaY,
        this.scope.paper.view.center,
        viewPosition
      );
      let newZoom = _ref1[0];
      this.currentZoom = newZoom;
      let offset = _ref1[1];
      this.scope.paper.view.zoom = newZoom;
      this.scope.paper.view.center = this.scope.paper.view.center.add(offset);
    } else if (zoomDelta) {
      let newZoom = Math.max(0.1, Math.min(1.5, this.currentZoom + zoomDelta));
      this.scope.paper.view.zoom = this.currentZoom = newZoom;
    }
    console.log("Current Zoom : ", this.currentZoom);
  }
  detectConnectedTiles(tile, parent) {
    tile.detected = true;
    let connectedTile = [];
    let topTile = this.getTileAtCellPosition(
      tile.cellPosition.add(new this.scope.paper.Point(0, -1))
    );
    let rightTile = this.getTileAtCellPosition(
      tile.cellPosition.add(new this.scope.paper.Point(1, 0))
    );
    let bottomTile = this.getTileAtCellPosition(
      tile.cellPosition.add(new this.scope.paper.Point(0, 1))
    );
    let leftTile = this.getTileAtCellPosition(
      tile.cellPosition.add(new this.scope.paper.Point(-1, 0))
    );

    if (
      topTile &&
      topTile != parent &&
      topTile.isfree &&
      !topTile.detected &&
      topTile.shape.bottomTab + tile.shape.topTab == 0 &&
      topTile.shape.bottomTab != 0 &&
      tile.shape.topTab != 0
    ) {
      topTile.detected = true;
      topTile.isfree = false;
      // topTile.opacity = 0.5;
      // topTile.cellPosition = undefined;
      connectedTile.push(topTile);
      connectedTile = this.merge_array(
        connectedTile,
        this.detectConnectedTiles(topTile, tile)
      );
    }
    if (
      rightTile &&
      rightTile != parent &&
      rightTile.isfree &&
      !rightTile.detected &&
      rightTile.shape.leftTab + tile.shape.rightTab == 0 &&
      rightTile.shape.leftTab != 0 &&
      tile.shape.rightTab != 0
    ) {
      rightTile.detected = true;
      rightTile.isfree = false;
      // rightTile.opacity = 0.5;
      // rightTile.cellPosition = undefined;
      connectedTile.push(rightTile);
      connectedTile = this.merge_array(
        connectedTile,
        this.detectConnectedTiles(rightTile, tile)
      );
    }
    if (
      bottomTile &&
      bottomTile != parent &&
      bottomTile.isfree &&
      !bottomTile.detected &&
      bottomTile.shape.topTab + tile.shape.bottomTab == 0 &&
      bottomTile.shape.topTab != 0 &&
      tile.shape.bottomTab != 0
    ) {
      bottomTile.detected = true;
      bottomTile.isfree = false;
      // bottomTile.opacity = 0.5;
      // bottomTile.cellPosition = undefined;
      connectedTile.push(bottomTile);
      connectedTile = this.merge_array(
        connectedTile,
        this.detectConnectedTiles(bottomTile, tile)
      );
    }
    if (
      leftTile &&
      leftTile != parent &&
      leftTile.isfree &&
      !leftTile.detected &&
      leftTile.shape.rightTab + tile.shape.leftTab == 0 &&
      leftTile.shape.rightTab != 0 &&
      tile.shape.leftTab != 0
    ) {
      leftTile.detected = true;
      leftTile.isfree = false;
      // leftTile.opacity = 0.5;
      // leftTile.cellPosition = undefined;
      connectedTile.push(leftTile);
      connectedTile = this.merge_array(
        connectedTile,
        this.detectConnectedTiles(leftTile, tile)
      );
    }
    return connectedTile;
  }
  merge_array(array1, array2) {
    const result_array = [];
    const arr = array1.concat(array2);
    let len = arr.length;
    const assoc = {};

    while (len--) {
      const item = arr[len];

      if (!assoc[item]) {
        result_array.unshift(item);
        assoc[item] = true;
      }
    }

    return result_array;
  }
  checkTiles() {
    let errors = 0;
    let firstTile = this.tiles[0];
    if (firstTile && firstTile.cellPosition) {
      let firstCellPosition = firstTile.cellPosition.subtract(
        this.cellPositionDiff
      );
      for (let y = 0; y < this.tilesPerColumn; y++) {
        for (let x = 0; x < this.tilesPerRow; x++) {
          let index = y * this.tilesPerRow + x;
          if (this.tiles[index].cellPosition && this.tiles[index].isfree) {
            let cellPosition = this.tiles[index].cellPosition.subtract(
              this.cellPositionDiff
            );
            let newPosition = firstCellPosition.add(
              new this.scope.paper.Point(x, y)
            );
            if (
              cellPosition &&
              (cellPosition.x != newPosition.x ||
                cellPosition.y != newPosition.y)
            ) {
              errors++;
            }
          } else {
            errors++;
          }
        }
      }
    } else {
      errors++;
    }
    return errors;
  }
  loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.addEventListener("load", () => {
        resolve(img);
      });
      img.addEventListener("error", (err) => {
        reject(err);
      });
      img.src = url;
    });
  }
  activateMessagePopup(json = null) {
    // hide other button
    const okButton = document.querySelector(".okButton");
    if (!okButton.classList.contains("hide")) okButton.classList.add("hide");
    const shareButton = document.querySelector(".shareButton");
    shareButton.classList.add("hide");
    const soloButton = document.querySelector(".soloButton");
    soloButton.classList.add("hide");
    const restartButton = document.querySelector(".restartButton");
    restartButton.classList.remove("hide");
    restartButton.addEventListener("click", () => {
      this.scope.resetApp();
    });
    if (this.scope.GAME_STATE != "win") {
      document.getElementById("my-dialog-title-sharing").textContent = this
        .scope.translator
        ? this.scope.translator.get("congratulations")
        : "Congratulations !";
    } else {
      document.getElementById("my-dialog-title-sharing").textContent = " ";
    }
    this.scope.artworkInfo.open();
    try {
      if (this.scope.axl) {
        this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "preview_asset",
          label: "static_modal / " + this.scope.artwork.asset_id,
          value: 0,
          nonInteraction: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  specialMessagePopUp(message) {
    // hide other button
    const okButton = document.querySelector(".okButton");
    if (!okButton.classList.contains("hide")) okButton.classList.add("hide");
    const shareButton = document.querySelector(".shareButton");
    shareButton.classList.add("hide");
    const soloButton = document.querySelector(".soloButton");
    soloButton.classList.add("hide");
    const restartButton = document.querySelector(".restartButton");
    restartButton.classList.remove("hide");
    restartButton.addEventListener("click", () => {
      this.scope.resetApp();
    });
    document.getElementById("my-dialog-title-sharing").textContent = message;
    // this.scope.artworkInfo.open();
  }

  win() {
    this.currentStatus = "win";
    this.activateMessagePopup();
    // --> send remote confirmation ->
    this.scope.send(
      "/GAMES/" +
        (this.scope.game_id ? this.scope.game_id : this.scope.UID) +
        "/datas/win",
      true
    );
    // --> ANALYTICS
    if (this.scope.axl) {
      this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "end_game",
        label: this.scope.game_id ? this.scope.game_id : this.scope.UID,
        value: 0,
        nonInteraction: false,
      });
    }
  }

  detectConflict(tile) {
    console.log("detect conflict");

    let hasConflict = false;

    let alreadyPlacedTile = this.getTileAtCellPosition(
      tile.connectedPosition,
      tile.master
    );
    if (alreadyPlacedTile != tile) {
      hasConflict = alreadyPlacedTile;
    }

    let topTile = this.getTileAtCellPosition(
      tile.connectedPosition.add(new this.scope.paper.Point(0, -1)),
      tile.master
    );
    let rightTile = this.getTileAtCellPosition(
      tile.connectedPosition.add(new this.scope.paper.Point(1, 0)),
      tile.master
    );
    let bottomTile = this.getTileAtCellPosition(
      tile.connectedPosition.add(new this.scope.paper.Point(0, 1)),
      tile.master
    );
    let leftTile = this.getTileAtCellPosition(
      tile.connectedPosition.add(new this.scope.paper.Point(-1, 0)),
      tile.master
    );

    if (topTile) {
      hasConflict =
        hasConflict || !(topTile.shape.bottomTab + tile.shape.topTab == 0);
    }

    if (bottomTile) {
      hasConflict =
        hasConflict || !(bottomTile.shape.topTab + tile.shape.bottomTab == 0);
    }

    if (rightTile) {
      hasConflict =
        hasConflict || !(rightTile.shape.leftTab + tile.shape.rightTab == 0);
    }

    if (leftTile) {
      hasConflict =
        hasConflict || !(leftTile.shape.rightTab + tile.shape.leftTab == 0);
    }

    return hasConflict;
  }

  removeGroupNavigation() {
    const nav = document.getElementById("groupNavigation");
    nav.removeEventListener("click", this.groupHandler);
    this.activeGroup = false;
    if (nav.classList.contains("active")) nav.classList.remove("active");
  }

  showGroupNavigation() {
    this.groupHandler = this.onGroup.bind(this);
    this.overHandler = this.onOver.bind(this);
    this.outHandler = this.onOut.bind(this);
    // interactive group nav
    const nav = document.getElementById("groupNavigation");
    nav.classList.remove("hide");
    nav.style.backgroundImage = 'url("./images/svg/separation.svg")';
    nav.addEventListener("click", this.groupHandler);
    nav.addEventListener("mouseover", this.overHandler);
    nav.addEventListener("mouseout", this.outHandler);
    this.isReady = true;
    if (this.scope.artwork && this.scope.artwork.isLoaded) {
      this.scope.artwork.hideLoader();
    }
  }
  onGroup(e) {
    const nav = document.getElementById("groupNavigation");
    nav.classList.toggle("active");
    if (nav.classList.contains("active")) {
      console.log("group is active");
      this.activeGroup = !this.isDragging ? true : false;
      if (!this.activeGroup)
        this.scope.UI.textContent = "You can move a group of pieces.";
    } else {
      console.log("group is not active");
      this.activeGroup = false;
    }

    if (this.scope.axl) {
      this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "group_option",
        label:
          "button / " + (nav.classList.contains("active") ? "group" : "free"),
        value: 0,
        nonInteraction: false,
      });
    }
  }
  unGroup() {
    const nav = document.getElementById("groupNavigation");
    nav.classList.remove("active");
  }
  onOver(e) {
    console.log(
      "OVER",
      'url("./images/svg/separationOver' +
        (document.body.classList.contains("dark") ? "_dark" : "") +
        '.svg")'
    );

    const nav = document.getElementById("groupNavigation");
    nav.style.backgroundImage =
      'url("./images/svg/separationOver' +
      (document.body.classList.contains("dark") ? "_dark" : "") +
      '.svg")';
  }
  onOut(w) {
    const nav = document.getElementById("groupNavigation");
    nav.style.backgroundImage =
      'url("./images/svg/separation' +
      (document.body.classList.contains("dark") ? "_dark" : "") +
      '.svg")';
  }
}
